import styled from 'styled-components'
import { UserStatuses } from '../../helpers/constants'

const statusColorHandler = (status) => {
  return status === UserStatuses.SENT ? 'var(--color-text-placeholder)' : 'rgba(136, 136, 136, 1)'
}

export const UserEmailContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const UserEmail = styled.div`
  font-size: 14px;
  color: var(--color-text-secondary);
`

export const UserStatusRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 2px 8px;
  word-break: normal;
`

export const UserStatus = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${props => statusColorHandler(props.status)};
`

export const ResendInviteButton = styled.button`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  gap: 4px;
  padding: 0;
  border: none;
  background: none;
  font-size: 12px;
  font-weight: 400;
  color: var(--color-text-expiry);
  text-decoration: underline;
text-underline-offset: 3px;
  white-space: nowrap;
  cursor: pointer;

  svg {
    flex-shrink: 0;
  }

  &:hover {
    opacity: 0.7;
  }
`
